import {
    UPDATE_USER,
    UPDATE_AUTH_TOKEN,
    UPDATE_FEATURES,
    UPDATE_LOCAL_PREFS,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    CLEAR_USER_ERRORS,
    UPDATE_USER_AVATAR
} from './Types';

import { IUserAction } from './userTypes';

const defaultState = {
    id: null,
    firstName: null,
    lastName: null,
    organisationName: null,
    prefs: {
        currentProjectId: null,
        homeBookmarkId: null
    },
    localPrefs: {
        reportForm: {
            includeRisk: true,
            riskOverride: null,
            includeSiteConstraints: true,
            siteConstraintsLayout: 'Category',
            includeValueSection: true,
            includePlanningApplications: true,
            includeRenewables: false,
            includePointsOfInterest: true,
            includeDeveloperInsight: true,
            includeAuthority: true,
            includePopulation: true,
            includeIMD: true,
            includeBuildableArea: true,
            includePotentialUnits: true
        }
    },
    authenticityToken: null,
    features: {},
    errors: {},
    avatar: ''
};

export default function reducer(state = defaultState, action: IUserAction) {
    switch (action.type) {
        case UPDATE_USER_REQUEST:
            return {
                ...state,
                isUserUpdating: true,
                userUpdatingError: ''
            };
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                isUserUpdating: false,
                userUpdatingError: '',
                errors: {}
            };
        case UPDATE_USER_FAILURE:
            return {
                ...state,
                isUserUpdating: false,
                userUpdatingError: 'Error updating user!',
                errors: action.errors
            };
        case UPDATE_USER:
            return {
                ...state,
                ...action.user,
                prefs: {
                    ...state.prefs,
                    ...action?.prefs
                }
            };
        case UPDATE_AUTH_TOKEN:
            return {
                ...state,
                authenticityToken: action.token
            };
        case UPDATE_FEATURES:
            return {
                ...state,
                features: action.features
            };
        case UPDATE_LOCAL_PREFS:
            return {
                ...state,
                localPrefs: {
                    ...state.localPrefs,
                    ...action.prefs
                }
            };
        case CLEAR_USER_ERRORS:
            return {
                ...state,
                errors: {}
            };
        default:
            return state;
    }
}
